import {
  useEffect,
  useRef,
  useState
} from 'react'
import { useDispatch } from 'react-redux'
import {
  Box,
  Stack
} from '@chakra-ui/react'
import { StyledButtonContainer } from 'common/Buttons/SingleButton/styled'
import dayjs from 'dayjs'
import {
  handleModalTitle,
  setPosts,
  setBlogParent,
  setOnPostEditor,
  setPostDraftData,
  setPostsTypeStatus,
  setProfilePostDraftData,
  setProfilePostDraftId
} from 'store'
import {
  SUCCEEDED,
  VERIFY_PAGE,
  ZOOM_LEVEL
} from 'utils/constants'
import { statusMarkerColor } from 'utils/helpers'
import { Affinities } from 'components/UserSection/SingleProfile/Affinities'
import { CodeWords } from 'components/UserSection/SingleProfile/CodeWords'
import { Connections } from 'components/UserSection/SingleProfile/Connections'
import { ShareProfile } from 'components/UserSection/SingleProfile/ShareProfile'
import { SocialLinks } from 'components/UserSection/SingleProfile/SocialLinks'
import { UserInformation } from 'components/UserSection/SingleProfile/UserInformation'
import { WalletAddress } from 'components/UserSection/SingleProfile/WalletAddress'

export const SingleProfile = ({
  setUserSectionPage,
  selectedUser,
  handleSelectLocation,
  hideIt,
  setHideIt,
  updateUserProfileStatus
}) => {
  const stackRef = useRef(null)
  const dispatch = useDispatch()
  const [copyText, setCopyText] = useState('Location')
  const [reload, setReload] = useState(0)
  const {
    full_name,
    affinities,
    social_links,
    profile_picture,
    banner,
    code_words,
    last_accessed,
    coordinates,
    personal_quote,
    past_connections,
    active_connections,
    connections_visibility,
    id,
    wallet_address
  } = selectedUser
  const validDate = dayjs(last_accessed)
  const statusColor = statusMarkerColor(validDate)

  const handleLocation = () => {
    setCopyText('Saved to Clipboard')
    handleSelectLocation(selectedUser)
    setTimeout(() => setCopyText('Location'), 1000)
    navigator.clipboard.writeText(
      process.env.REACT_APP_FRONTEND_URL
      + '?lat=' + coordinates[0]
      + '&lng=' + coordinates[1]
      + '&zoom=' + ZOOM_LEVEL
    )
  }

  useEffect(() => {
    if (updateUserProfileStatus === SUCCEEDED) {
      dispatch(handleModalTitle(VERIFY_PAGE.SingleProfile))
    }
  }, [updateUserProfileStatus])

  useEffect(() => {
    dispatch(handleModalTitle(VERIFY_PAGE.SingleProfile))
  }, [])

  useEffect(() => {
    setReload(Math.random())
  }, [selectedUser])

  return (
    <Stack
      ref={stackRef}
      direction="column"
      spacing="16px"
      {...(hideIt ? {
        width: `${stackRef?.current?.offsetWidth}px`,
        position: 'absolute',
        zIndex: -111
      } : {})}
      {...(full_name ? {} : { display: 'none' })}
      padding="24px 65px"
    >
      {reload && (
        <>
          <UserInformation
            profilePicture={profile_picture}
            fullName={full_name}
            lastAccessed={last_accessed}
            setUserSectionPage={setUserSectionPage}
            quote={personal_quote}
            coverPicture={banner}
          />
          <Connections
            activeConnections={active_connections}
            pastConnections={past_connections}
            isShowConnections={connections_visibility}
            statusColor={statusColor}
          />
          <CodeWords codeWords={code_words} />
          <Affinities affinities={affinities} />
          <SocialLinks socialLinks={social_links} />

          <Stack
            width="100%"
            marginTop="30px"
            spacing="16px"
            position="relative"
          >
            <ShareProfile id={id} />
            <WalletAddress
              id={id}
              walletAddress={wallet_address}
            />
            <StyledButtonContainer
              name="open-profile-blog"
              onClick={() => {
                dispatch(setPosts([]))
                dispatch(setBlogParent([]))
                dispatch(setOnPostEditor(''))
                dispatch(setPostsTypeStatus('posted'))
                dispatch(handleModalTitle(VERIFY_PAGE.ProfileBlog))
                dispatch(setPostDraftData([]))
                dispatch(setProfilePostDraftId(null))
                dispatch(setProfilePostDraftData([]))
                setHideIt(true)
              }}
            >
              Blogs
            </StyledButtonContainer>
            <StyledButtonContainer
              onClick={() => handleLocation()}
              name="profile-location"
            >
              {copyText}
            </StyledButtonContainer>
            <StyledButtonContainer
              name="edit-profile"
              onClick={() => {
                document.querySelector('#chakra-modal--body-user-drawer').scrollTop = 0
                dispatch(handleModalTitle(VERIFY_PAGE.EditProfile))
                setHideIt(true)
              }}
            >
              Edit
            </StyledButtonContainer>

            <Box
              id="bottomBox"
              position="absolute"
              bottom="-10"
            />
          </Stack>
        </>
      )}
    </Stack>
  )
}
